import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { AddMembershipIconSmall, deleteIconSVG } from "../../assets/SVGs/SVGs";
import SubInfo from "../admin/common/SubInfo";

type Props = {
  memberships: any;
  setMemberships: any;
  currentStep: number;
};

const ListSoldMembership = ({
  memberships,
  setMemberships,
  currentStep,
}: Props) => {
  const intl = useIntl();
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number | null } }) => state.calendar
  );
  const removeMembershipsItem = (index: number) => {
    const newMemberships = memberships.filter(
      (_: any, i: number) => i !== index
    );
    setMemberships(newMemberships);
  };
  console.log(memberships);
  const getExpiryDurationInDays = (duration: string) => {
    let days = 0;
    switch (duration) {
      case "one_month":
        days = 30;
        break;
      case "three_months":
        days = 90;
        break;
      case "six_months":
        days = 180;
        break;
      case "one_year":
        days = 365;
        break;
    }
    return days;
  };
  return (
    <div
      style={{ marginTop: memberships ? "" : "" }}
      className="flex flex-col gap-2 text-sm"
    >
      {memberships.map((membership: any, index: any) => {
        return (
          <div
            style={{ border: "1px solid #EEF0FF" }}
            className="flex items-center justify-between h-full bg-[#FBFBFF] px-3 py-2"
          >
            <div className="flex flex-col items-center justify-between w-full gap-2 px-3 py-2 rounded-lg">
              <div className="flex items-center justify-start w-full gap-2 text-color-primary">
                <span>{AddMembershipIconSmall}</span>{" "}
                <span>{membership?.name}</span>
              </div>
              <div className="flex items-center justify-between w-full text-xs">
                <div className="flex items-center gap-4">
                  <span className="text-[#75757E]">
                    {membership?.pricing_option?.length}{" "}
                    {intl.formatMessage({ id: "services" })}
                  </span>
                  <span className="text-[#75757E]">
                    {membership?.sessions}{" "}
                    {intl.formatMessage({ id: "sessions" })}
                  </span>
                  <SubInfo
                    value={getExpiryDurationInDays(membership?.expire_duration)}
                    label={intl.formatMessage({ id: "day" })}
                  />
                </div>
                <SubInfo
                  value={+membership?.price}
                  label={intl.formatMessage({ id: "saudi_riyal" })}
                />
              </div>
            </div>
            <div
              className="flex items-center h-full cursor-pointer w-fit"
              onClick={() => removeMembershipsItem(index)}
              style={{ borderRight: "1px solid #9999A7" }}
            >
              <div className="p-3">{deleteIconSVG}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ListSoldMembership;
